import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ATTRIBUTION_MODE_CHERRYPICK } from '../../../contexts/AbstractContext';
import {
    FETCH_MODE_FEED,
    Provider as CommunityContextProvider,
} from '../../../contexts/CommunityContext';
import { COMPANY_PROPTYPES } from '../../Includes/CompanyProps';
import Layout from '../../Layout/Layout';
import PageSection from '../../Layout/PageSection/PageSection';
import CompanyHeaderSticky from '../../Layout/StickyTopBar/CompanyHeaderSticky/CompanyHeaderSticky';
import './CompanyPageLayout.scss';
import { PageContext } from '../../../contexts/ContextCreator';

const CompanyPageLayout = ({
    children,
    additionalTopBannerOnlyShownList,
    topics,
    company,
    shouldSubNavOpenNewTabs,
}) => {
    const { pageProps } = useContext(PageContext);
    return (
        <div className="component-CompanyPages-CompanyPageLayout">
            <Layout
                PAGE_PROPS={pageProps}
                topBannerExclusionList={['community-onboard']}
                topBannerOnlyShownList={[
                    'job-seeker-profile',
                    ...additionalTopBannerOnlyShownList,
                ]}
            >
                <CommunityContextProvider
                    fetchMode={FETCH_MODE_FEED}
                    attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                    content={[]}
                    topics={topics}
                >
                    <CompanyHeaderSticky
                        company={company}
                        userId={pageProps.session.id}
                        shouldSubNavOpenNewTabs={shouldSubNavOpenNewTabs}
                    >
                        {React.Children.map(children, (child, idx) => {
                            /* eslint-disable react/no-array-index-key */
                            return (
                                <PageSection className="" key={idx}>
                                    {child}
                                </PageSection>
                            );
                        })}
                    </CompanyHeaderSticky>
                </CommunityContextProvider>
            </Layout>
        </div>
    );
};

CompanyPageLayout.propTypes = {
    company: PropTypes.shape(COMPANY_PROPTYPES).isRequired,
    children: PropTypes.node.isRequired,
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            url: PropTypes.string,
            layout: PropTypes.string,
            total: PropTypes.number,
            isDefault: PropTypes.number,
            sponsored: PropTypes.bool,
            qaDataAttr: PropTypes.string,
        })
    ).isRequired,
    /**
     * addtional items for topBannerOnlyShownList to be pass to TopbannerController
     */
    additionalTopBannerOnlyShownList: PropTypes.arrayOf(PropTypes.string),
    shouldSubNavOpenNewTabs: PropTypes.bool,
};

CompanyPageLayout.defaultProps = {
    shouldSubNavOpenNewTabs: false,
    additionalTopBannerOnlyShownList: [],
};

export default React.memo(CompanyPageLayout);
